import { DemandIntentDocument } from '@models/demand/demand-intent-document.model'
import { NoticeSessionStatus } from '@models/planning/notice-session.model'
import { ProcessBidType, ProcessDisputeMode, ProcessJudgingCriteria, ProcessModality } from '@models/planning/process.model'

/** Sessão do processo para o visitante (spec 048, RF 24 e 25). Sem `opened`, só status e data e hora previstas. */
export class VisitorSessionInfo {
	id: string
	status?: NoticeSessionStatus
	scheduledDate?: string
	scheduledTime?: string
	opened?: boolean
	openedAt?: string
	closedAt?: string
	bidTimerMinutes?: number
	forcedClosure?: boolean
	inReopening?: boolean
	chatRoomId?: string

	constructor(source?: Partial<VisitorSessionInfo>) {
		if (source) {
			Object.assign(this, source)
		}
	}
}

export class VisitorProcessSession {
	demandId: string
	externalCode: string
	tenantId: string
	modality?: ProcessModality
	disputeMode?: ProcessDisputeMode
	judgingCriteria?: ProcessJudgingCriteria
	bidType?: ProcessBidType
	openStageMinutes?: number
	minIntervalBetweenBids?: number
	qualificationInversion?: boolean
	budgetConfidential?: boolean
	/** A modalidade tem sessão para o visitante (Pregão, Concorrência sem avaliação técnica e Dispensa). */
	available?: boolean
	session?: VisitorSessionInfo | null

	constructor(source?: Partial<VisitorProcessSession>) {
		if (source) {
			Object.assign(this, source)
			this.session = source.session ? new VisitorSessionInfo(source.session) : null
		}
	}

	get sessionId(): string | null {
		return this.session?.id ?? null
	}

	get opened(): boolean {
		return !!this.session?.opened
	}

	get chatRoomId(): string | null {
		return this.session?.chatRoomId ?? null
	}

	/**
	 * A demanda que os painéis do participante leem (`bidBoardDemand`), montada só com o que o servidor do visitante
	 * entrega. O sigilo do orçamento vem já decidido (`budgetConfidential`): sigiloso e não revelado, ou nada.
	 */
	toDemand(): DemandIntentDocument {
		return new DemandIntentDocument({
			id: this.demandId,
			tenantId: this.tenantId,
			externalCode: this.externalCode,
			reversalQualificationPhase: this.qualificationInversion,
			process: {
				modality: this.modality,
				disputeMode: this.disputeMode,
				judgingCriteria: this.judgingCriteria,
				bidType: this.bidType,
				openStageMinutes: this.openStageMinutes,
				minIntervalBetweenBids: this.minIntervalBetweenBids,
				confidentialNature: !!this.budgetConfidential,
				budgetRevealedAt: null
			} as any,
			noticeSession: {
				id: this.session?.id,
				tenantId: this.tenantId,
				status: this.session?.status,
				openedDate: this.session?.scheduledDate,
				openedTime: this.session?.scheduledTime,
				sessionOpenedAt: this.session?.openedAt,
				sessionClosedAt: this.session?.closedAt,
				bidTimerMinutes: this.session?.bidTimerMinutes,
				forcedClosure: this.session?.forcedClosure,
				latestReopening: this.session?.inReopening ? { id: this.session.id, createdAt: this.session.openedAt } : undefined
			} as any
		})
	}
}
